import { lazy } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import type { AppletDefinition } from '../../applets';
import StudioShellLayout from '../StudioShellLayout';

const LazyBatchCharacter = lazy(async () => {
  const { BatchCharacter } = await import('./components/UploadScreen');
  return { default: BatchCharacter };
});

const applet = {
  id: 'character',
  path: '/character',
  paths: [
    '/character',
    '/character/:id',
    '/character-generation',
    '/character-generation/:id',
    '/batch-character/:id',
  ],
  label: 'Character Generator',
  description: 'Text or image-to-rigged 3D.',
  dashboard: {
    badge: 'New',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/v2_product_character_gen_hero_dashboard.webm',
    title: 'Character Generator',
    description: 'Rigged 3D characters from prompt or art',
    order: 55,
  },
  policy: {
    requiresLoggedIn: false,
    requiresApiKey: 'soft',
  } satisfies Policy,
  component: LazyBatchCharacter,
  layout: StudioShellLayout,
} satisfies AppletDefinition;

export default applet;
